/**
 * El portal — donde se escogen los módulos, y la primera pantalla después de iniciar sesión.
 *
 * `cuadrilla` for crew. It is the word used on a Mexican or Central American job site; `equipo` would
 * collide with `Equipo` = equipment, which the QR page already fixed in the field.
 *
 * `Resumen` for "KPI Summary". KPI is English management jargon that means nothing to a foreman
 * reading it in either language, and the heading is above four numbers — "Resumen" is what those
 * numbers are.
 *
 * `Horas extras` for overtime. `Tiempo extra` is also heard, but `horas extras` is the phrase used on
 * a Mexican pay stub, and this number is about pay.
 */
export default {
  dashboard: 'Panel',
  goodMorning: 'Buenos días',
  goodAfternoon: 'Buenas tardes',
  goodEvening: 'Buenas noches',
  refresh: 'Actualizar',
  user: 'Usuario',
  view: 'Ver',

  // ── tarjeta del perfil ────────────────────────────────────────────────────────────────────────
  editProfile: 'Editar mi perfil',
  adminPanel: 'Administración',

  // ── notificaciones ────────────────────────────────────────────────────────────────────────────
  notifications: 'Notificaciones',
  markAllRead: 'Marcar todo como leído',
  noNewNotifications: 'No hay notificaciones nuevas',
  notificationsHint: 'Aquí aparecen los avisos de horas, de presupuestos y del sistema.',
  timekeepingNotification: 'Aviso de control de horas',

  // ── títulos de las secciones ──────────────────────────────────────────────────────────────────
  kpiSummary: 'Resumen',
  quickActions: 'Acciones rápidas',
  modules: 'Módulos',
  noModules: 'No tiene módulos disponibles',
  noModulesHelp: 'Hable con su administrador para que le den acceso.',
  soon: 'Pronto',
  comingSoon: (name) => `${name} estará disponible pronto.`,

  // ── un módulo cuyo servidor no contesta ───────────────────────────────────────────────────────
  serviceOffline: 'Servicio fuera de línea',
  serviceOfflineHelp: 'Inicie el servidor para cargar los datos',
  // ── un módulo que contestó, y la respuesta fue no ─────────────────────────────────────────────
  accessRefused: 'Su cuenta no puede ver esto',
  accessRefusedHelp: 'Pídaselo a un administrador si lo necesita.',

  // ── control de horas ──────────────────────────────────────────────────────────────────────────
  previousWeek: 'Semana anterior',
  nextWeek: 'Semana siguiente',
  thisWeek: 'Esta semana',
  lastWeek: 'Semana pasada',
  reportsCreated: 'Reportes creados',
  awaitingApproval: 'Esperando aprobación',
  crewHours: 'Horas de la cuadrilla',
  regularHours: 'Horas normales',
  overtimeHours: 'Horas extras',

  // ── proyectos / presupuestos / personal / clientes / usuarios ─────────────────────────────────
  activeProjects: 'Proyectos activos',
  totalProjects: 'Total de proyectos',
  bidRequests: 'Solicitudes de presupuesto',
  totalRequests: 'Total de solicitudes',
  pending: 'Pendientes',
  assigned: 'Asignadas',
  completed: 'Terminadas',
  pipelineValue: 'Valor en proceso',
  awardedValue: 'Valor ganado',
  activeBids: 'Presupuestos activos',
  winRate: 'Tasa de éxito',
  activeEmployees: 'Empleados activos',
  totalRecords: 'Total de registros',
  totalClients: 'Total de clientes',
  activeClients: 'Clientes activos',
  systemUsers: 'Usuarios del sistema',
  activeAccounts: 'Cuentas activas',
  totalRegistered: 'Total registrados',

  // ── acciones rápidas ──────────────────────────────────────────────────────────────────────────
  qaTimekeeping: 'Enviar mis horas',
  qaBidRequest: 'Nueva solicitud de presupuesto',
  qaBidWorkup: 'Abrir presupuestos',
  qaProjects: 'Ver proyectos',
  qaHr: 'Panel de Recursos Humanos',
  qaCrm: 'Panel de CRM',
  qaDocuments: 'Control de Documentos',
  qaFleet: 'Panel de Flota',
  qaFinance: 'Finanzas',
}
